module.exports = __webpack_public_path__ + "static/rami-e23bf51035e6db63ab91552d2d80f330.jpg";